const withCommonRoot = require('client-v2/common/components/root')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const AppFooter = require('client-v2/common/containers/app-footer/component-smart')
const AppNav = require('client-v2/common/containers/app-nav/component-smart')
// Entry imports
const BannerSection = require('client-v2/logged-out-landing-v2/containers/banner-section/component-smart')
const DeviceSection = require('client-v2/logged-out-landing-v2/components/device-section')
const FeedSection = require('client-v2/logged-out-landing-v2/components/feed-section')
const HeroSection = require('client-v2/logged-out-landing-v2/containers/hero-section/component-smart')
const MixSection = require('client-v2/logged-out-landing-v2/components/mix-section')

const bem = BemEntity('LoggedOutLandingLayout')

function LoggedOutLandingLayout() {
  return (
    tag('div', {
      className: bem.block()
    },
      tag('div', {
        className: bem.element('page')
      },
        tag('div', {
          className: bem.element('body')
        },
          tag(BannerSection),
          tag(FeedSection),
          tag(HeroSection),
          tag(MixSection),
          tag(DeviceSection)
        ),
        tag(AppFooter),
        tag(AppNav, {
          className: 'AppNav--mobile'
        })
      )
    )
  )
}

// module.exports = LoggedOutLandingLayout
const wrappedComponent = withCommonRoot(LoggedOutLandingLayout)
module.exports = Object.assign(wrappedComponent, {
  // Export unwrapped component for testing purposes
  LoggedOutLandingLayout
})
